import React from "react";
import { MIN_GUEST_AGE_YEARS } from "../../utils/bookingHelpers";

export default function BookingUserForm({
  isTable,
  maleGuests,
  femaleGuests,
  guestCount,
  setMaleGuests,
  setFemaleGuests,
  setGuestCount,
  availabilityMeta,
  maxGuest,
  minGuest,
  submitting,
  checking,
  selectedDate,
  isDateAvailable,
  canProceed,
  onNext,
}) {
  const readyToProceed =
    typeof canProceed === "boolean"
      ? canProceed
      : Boolean(selectedDate && isDateAvailable);
  return (
    <div className="booking-guest-wrap">
      <p className="booking-section-title">{isTable ? "Add Guests" : "Add Member"}</p>
      {isTable ? (
        <div className="booking-guest-rows">
          <div className="booking-guest-row">
            <span className="booking-guest-label">Male guests</span>
            <div className="booking-counter">
              <button type="button" onClick={() => setMaleGuests((v) => Math.max(0, v - 1))}>
                -
              </button>
              <span>{maleGuests}</span>
              <button type="button" onClick={() => setMaleGuests((v) => v + 1)}>
                +
              </button>
            </div>
          </div>
          <div className="booking-guest-row">
            <span className="booking-guest-label">Female guests</span>
            <div className="booking-counter">
              <button type="button" onClick={() => setFemaleGuests((v) => Math.max(0, v - 1))}>
                -
              </button>
              <span>{femaleGuests}</span>
              <button type="button" onClick={() => setFemaleGuests((v) => v + 1)}>
                +
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="booking-member-card">
          <div className="booking-member-head">
            <div className="booking-member-title-wrap">
              <div className="booking-member-title-row">
                <span className="booking-guest-label">Member</span>
                <div className="booking-counter">
                  <button type="button" onClick={() => setGuestCount((v) => Math.max(0, v - 1))}>
                    -
                  </button>
                  <span>{guestCount}</span>
                  <button type="button" onClick={() => setGuestCount((v) => v + 1)}>
                    +
                  </button>
                </div>
              </div>
              <span className="booking-member-sub">
                Ages {MIN_GUEST_AGE_YEARS} years and above
              </span>
            </div>
          </div>
          <div className="booking-member-stats">
            <span className="booking-member-cap">Max capacity: {maxGuest || 250} members</span>
            {availabilityMeta ? <span className="booking-member-cap">{availabilityMeta}</span> : null}
          </div>
        </div>
      )}

      {!isTable ? (
        <div className="booking-guest-footer">
          <button
            type="button"
            onClick={onNext}
            disabled={submitting || checking || !readyToProceed}
            className="booking-primary-btn"
          >
            {submitting ? "Processing..." : "Next"}
          </button>
        </div>
      ) : null}

    </div>
  );
}
